import { trackPromise } from 'react-promise-tracker';
import { create } from 'zustand';
import { getUniqueId } from '../common/common';
import { getNotificationStyle } from '../common/notification';
import { IManifestChargeFilter } from '../components/FilterComponent/ManifestChargeFilterComponent';
import { IFetchFiles, IFile } from '../model/BookingModel';
import { IAssignUnAssignType, ICancelRequest, ICommonState, IComplaintAssignment, IComplaintCommentsList, ICustomerComplaintFilter, ICustomerComplaintList, IFilter, IFuelFilterParams, IFuelAuditPaginatedFilterParams, IFuelTrackingRequest, IGetFiles, IGoogleMap, IManifestFileUploads, IManifestSalesManList, IMarkenResponse, INotify, IPieceTrackingSearchFilter, IPieceType, IPodFilterParams, IPodWaybillsRequestList, IPrintBarCodes, IPrintPieceBarCodes, IPrintPieceBarcodes, ISalesPerson, ISalesPersonManifestRejectRequest, ISalesPersonManifestRespond, IShipmentSummaryDetailsRequest, IShipmentSummaryRequest, IVehicleVisibility, IVehicleVisibilityFilter, MetabaseRequestData, PaginationParams, IOdometerFilterParams, IOdometerRequest, IFTLTripPlanFilterParams, IdleVehicleFilterParams, InvoiceStaging, ICROPerson } from '../model/CommonModel';
import { UploadFileService } from '../services/booking-service';
import { AddFuelTrackingService, AdhocAssignUnAssignService, AssignComplaintService, AssignUnAssignService, CancelService, ConfirmManifestByIdService, DownloadFilesActionService, DownloadManifestFilesService, DownloadMarkenFilesService, DownloadSingleFileService, EditFuelTrackingService, ExportPendingCashService, GetActivityListService, GetAirportCodeListService, GetBusinessService, GetCityGroupService, GetCommentByComplaintService, GetComplaintCategoryListService, GetComplaintHistoryByComplaintService, GetComplaintPriorityListService, GetComplaintStatusListService, GetComplaintSubCategoryByCategoryService, GetComplaintUploadFileService, GetCurrencyService, GetCustomerComplaintByIdService, GetCustomerComplaintListService, GetCustomerInfoByWaybillService, GetDivisionService, GetDriverAssignmentByIdService, GetEmployeeDropDownService, GetExceptionCategoryService, GetExceptionListByCategoryIdService, GetFtlOriginListService, GetFuelAuditHistoryService, GetFuelAuditPaginatedService, GetFuelPaymentModesService, GetFuelRateListService, GetFuelStationsService, GetFuelTrackingListService, GetIndustriesGroupListService, GetIndustryListService, GetManifestFilesListService, GetManifestSalesmanService, GetMarkenByIdService, GetMarkenFilesListService, GetMetabaseReportListService, GetMetabaseSignedTokenService, GetOriginListService, GetPackageSizeListService, GetPackageTempListService, GetPackagingListService, GetPickupCountForMonthService, GetPieceLevelService, GetPodClosedPaginatedService, GetPodCloseService, GetPodDispatchWaybillsPageService, GetPodDispatchWaybillsService, GetPodInProgressPaginatedService, GetPodInProgressService, GetPodPendingService, GetPodWaybillsService, GetPositionService, GetRegionByCountryListService, GetSalesPersonService, GetShipmentStatusCountForDayService, GetShipmentStatusDetailForDayService, GetShipmentTemperatureListService, GetStationService, GetSubCityListService, GetTripplanDriverStatusListService, GetTruckTypeListService, GetUploadedFileListService, GetVehicleAssignmentByIdService, GetVehicleStatusHistoryByIdService, GetVehicleVisibilityByIdService, GetVehicleVisibilityListService, NotifyDriverService, PrintBarCodeService, PrintCashRecieptService, PrintDeliverySheetService, PrintIRSReportService, PrintPalletService, PrintPieceBarCodeService, PrintPieceBarcodeService, PrintPodDispatchService, PrintStickerService, PrintWayBillService, RejectManifestByIdService, SaveCustomerComplaintCommentsService, SaveCustomerComplaintService, SaveMarkenService, SavePodWaybillsService, SearchComplaintFilterService, SearchPieceBarcodeTrackingFilterService, SearchVehicleVisibilityFilterService, UpdateCustomerComplaintService, UpdateMarkenService, UpdateVehicleVisibilityByIdService, UploadManifestFileService, EditOdometerService, GetOdometerListService, GetFTLNonAutoTripPlanWaybillsService, GetIdleVehicleListService, GetIdleVehicleByIdService, CreateIdleVehicleExceptionService, EditIdleVehicleExceptionService, CancelIdleVehicleExceptionService, ApproveRejectIdleVehicleExceptionService, GetCustomerConfigService, GetCaseClosureTypesService, GetCnNoteReasonsService, GetInvoiceStagingService, PushToOracleStagingService, RevalidateInvoiceStagingService, AllowEditInvoiceStagingService, GetCROEmployeesService, GetRouteTypesService } from '../services/common-service';
import { SessionStorage } from '../services/storage';
import { ACTIVE_STATUS_ID, CUSTOMER_COMPLAINT, DEFAULT_CURRENT, DEFAULT_PAGE_SIZE, TWO_HUNDRED_SUCCESS_CODE, createFormData, downloadBlob, downloadURL, isAoneUrl } from '../utils/app-common';
import { ICommonInitialState } from './../model/CommonModel';
import { IPrintPallet } from './../model/PalletModel';
import { PositionEnum, UserEnum } from './../utils/app-common';
import { CustomerUploadFormData, responseData } from "./common";
import { convertMillisToDateMoment, addLeadingZero } from '../utils/luxon';
import { number } from 'echarts';

const initialValue: ICommonInitialState = {
    originList: [],
    destinationList: [],
    cargoOrigins: [],
    originSubCityList: [],
    consigneeSubCityList: [],
    subCityList: [],
    industryList: [],
    salesPersonList: [],
    currencyList: [],
    divisionList: [],
    businessList: [],
    positionList: [],
    stationList: [],
    employeeDropDownList: [],
    exceptionCategoryList: [],
    cityGroupList: [],
    regionByCountryList: [],
    googlePosition: {},
    download: {},
    manifestFiles: [],
    fileUploadResponse: undefined,
    exceptionReasonList: [],
    tripplanDriverStatusList: [],
    pieceLevelList: [],
    podDispatchPendingList: [],
    podDispatchInProgressList: [],
    totalPodDispatchInProgress: 0,
    podClosedList: [],
    totalPodClosed: 0,
    podDispatchWaybillsList: {},
    podWaybillsList: [],
    industryGroupList: [],
    pieceBarcodeTrackingList: [],
    activityList: [],
    packagingList: [],
    truckTypeList: [],
    markenRequestList: [],
    airportCodeList: [],
    shipmentTemperatureList: [],
    packageTempList: [],
    packageSizeList: [],
    markenFiles: [],
    manifestSalesman: [],
    customerComplaintList: [],
    customerComplaintCategoryList: [],
    customerComplaintPriorityList: [],
    customerComplaintStatusList: [],
    customerComplaintRequestList: [],
    customerComplaintCommentsList: [],
    customerComplaintSubCategoryList: [],
    customerInfo: {},
    complaintHistoryList: [],
    uploadedFiles: [],
    customerComplaintSavingResponse: undefined,
    uploadedFileList: [],
    pagination: {},
    vehicleVisibilityList: [],
    deliveryDrivers: [],
    assignedDrivers: [],
    vehicleVisibilityIdList: [],
    vehicleStatusHistoryList: [],
    middlewares: {},
    assignedVehicle: {},
    pickupCountForMonthList: [],
    shipmentStatusCountForDayList: [],
    shipmentStatusDetailForDayList: [],
    shipmentStatusDetailForDayTotal: 0,
    fuelPaymentModes: [],
    fuelStations: [],
    fuelTrackingList: [],
    fuelTrackingTotal: 0,
    fuelAuditHistory: [],
    fuelAuditPaginatedList: [],
    fuelAuditPaginatedTotal: 0,
    fuelRateList: [],
    odometerList: [],
    odometerTotal: 0,
    metabaseReportList: [],
    metabaseSignedToken: "",
    ftlNonAutoTripPlanWaybills: [],
    ftlNonAutoTripPlanWaybillsTotal: 0,
    idleVehicleList: [],
    idleVehicleTotal: 0,
    idleVehicle: undefined,
    customerConfig: null,
    invoiceStaging: [],
    cnNoteReasonsList: [],
    ComplaintCaseTypesList: [],
     croPersonList: [],
       routeTypeList: [],
}

const CommonStore = create<ICommonState>(((set, get) => ({
    ...initialValue,
    GetOriginListAction: async (id: number, name = 'origin' as string) => {
        const response = await GetOriginListService(id);
        if (name?.includes('destination')) {
            set({ destinationList: responseData(response?.data) });
            return;
        }
        if (name?.includes('cargoOriginCity')) {
            set({ cargoOrigins: responseData(response?.data) });
            return;
        };
        set({ originList: responseData(response?.data) })
    },
    GetFtlOriginListAction: async (id: number, name = 'origin' as string) => {
        const response = await GetFtlOriginListService(id);
        if (name?.includes('destination')) {
            set({ destinationList: responseData(response?.data) });
            return;
        }
        if (name?.includes('cargoOriginCity')) {
            set({ cargoOrigins: responseData(response?.data) });
            return;
        };
        set({ originList: responseData(response?.data) })
    },
    GetSubCityListAction: async (id?: number) => {
        const response = await GetSubCityListService(id);
        set({ subCityList: responseData(response?.data) })
    },
    GetConsigneeSubCityListAction: async (id: number) => {
        const response = await GetSubCityListService(id);
        set({ consigneeSubCityList: responseData(response?.data) })
    },
    GetIndustryListAction: async () => {
        const response = await GetIndustryListService();
        set({ industryList: responseData(response?.data) })
    },
    GetSalesPersonAction: async () => {
        const response = await GetSalesPersonService();
        set({ salesPersonList: responseData(response?.data)?.filter((salesPerson: ISalesPerson) => salesPerson?.statusId === ACTIVE_STATUS_ID) })
    },
    GetCurrencyAction: async () => {
        const response = await GetCurrencyService();
        set({ currencyList: responseData(response?.data) })
    },
    PrintWayBillAction: async (airWayBill: string) => {
        const response = await PrintWayBillService(airWayBill);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            downloadBlob(responseData(response?.data), `${airWayBill}.pdf`);
        }
    },
    PrintStickerAction: async (airWayBill: string) => {
        const response = await PrintStickerService(airWayBill);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            downloadBlob(responseData(response?.data), `${airWayBill}.pdf`);
        }
    },
    PrintPalletAction: async (data: IPrintPallet[], masterPalletCode: string) => {
        const response = await PrintPalletService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            downloadBlob(responseData(response?.data), `${masterPalletCode}.pdf`);
        }
    },
    GetDivisionListAction: async () => {
        const response = await GetDivisionService();
        set({ divisionList: responseData(response?.data) })
    },
    GetBusinessListAction: async () => {
        const response = await GetBusinessService();
        set({ businessList: responseData(response?.data) })
    },
    GetPositionListAction: async () => {
        const response = await GetPositionService();
        const { positionId } = JSON.parse(SessionStorage.get('employee') || '') || {};
        let data = responseData(response?.data);
        if (positionId === UserEnum.FLEET_SUPERVISOR) {
            data = data.filter(item => ![PositionEnum.ADMIN, PositionEnum.FINANCE, PositionEnum.MANAGER, PositionEnum.MANIFESTER, PositionEnum.OPS_MANAGER].includes(item?.id))
        };
        set({ positionList: data })
    },
    GetStationListAction: async () => {
        const response = await GetStationService();
        set({ stationList: responseData(response?.data) })
    },
    GetEmployeeDropDownListAction: async () => {
        const response = await GetEmployeeDropDownService();
        set({ employeeDropDownList: responseData(response?.data) })
    },
    GetExceptionCategoryListAction: async () => {
        const response = await GetExceptionCategoryService();
        set({ exceptionCategoryList: responseData(response?.data) })
    },
    GetCityGroupListAction: async () => {
        const response = await GetCityGroupService();
        set({ cityGroupList: responseData(response?.data) })
    },
    GetRegionByCountryListAction: async (id: number) => {
        const response = await GetRegionByCountryListService(id);
        set({ regionByCountryList: responseData(response?.data) })
    },
    SaveGooglePosition: (data: IGoogleMap) => {
        set({ googlePosition: data })
    },
    DownloadFilesAction: async (id: number, fileName: string, fileFormat: string) => {
        const response = await DownloadFilesActionService(id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ download: responseData(response?.data) });
            trackPromise(downloadBlob(responseData(response?.data), fileName, fileFormat), 'download-file-area');
        }
    },
    GetUploadedFileListAction: async (request: IGetFiles, onFinish?: () => void) => {
        set({ uploadedFileList: [] });
        const response = await GetUploadedFileListService(request);
        const { statusCode } = response?.data || {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) getNotificationStyle(response);
        set({ uploadedFileList: responseData(response?.data) });
        onFinish?.();
    },
    GetManifestFilesListAction: async (wayBillNumber?: string) => {
        const response = await GetManifestFilesListService(wayBillNumber);
        set({ manifestFiles: responseData(response?.data) });
    },
    UploadManifestFileAction: async (fileObject: IManifestFileUploads, waybillNo?: string) => {
        const response = await UploadManifestFileService(fileObject);
        set({ fileUploadResponse: response?.status });
        getNotificationStyle({ ...response, statusText: responseData(response?.data?.message) });
        trackPromise(get().GetManifestFilesListAction(waybillNo), 'files-list-area')
    },
    DownloadManifestFilesAction: async (id: number, fileName: string, fileFormat: string) => {
        const response = await DownloadManifestFilesService(id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ download: responseData(response?.data) });
            downloadBlob(responseData(response?.data), fileName, fileFormat);
        }
    },
    PrintBarCodeAction: async (request: IPrintBarCodes[]) => {
        const response = await PrintBarCodeService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            downloadBlob(responseData(response?.data), `barcode.pdf`);
        }
    },
    GetExceptionListByCategoryIdAction: async (id: number | undefined) => {
        const response = await GetExceptionListByCategoryIdService(id);
        set({ exceptionReasonList: responseData(response?.data) })
    },
    GetTripplanDriverStatusListAction: async () => {
        const response = await GetTripplanDriverStatusListService();
        const convertedResponse = responseData(response?.data);
        set({ tripplanDriverStatusList: convertedResponse })
    },
    PrintPieceBarcodeAction: async (data: IPrintPieceBarcodes) => {
        const response = await PrintPieceBarcodeService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            downloadBlob(responseData(response?.data), `${data.waybillNo}.pdf`);
        }
    },
    PrintPieceBarCodeAction: async (data: IPrintPieceBarCodes) => {
        const response = await PrintPieceBarCodeService(data);
        const { statusCode } = response?.data || {}
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            const data = responseData(response?.data);
            data?.forEach(element => {
                trackPromise(downloadURL(element?.response), 'download-file-area')
            });
        }
    },
    GetPieceLevelAction: async (request: IPieceType) => {
        const response = await GetPieceLevelService(request);
        const convertedResponse = responseData(response?.data);
        set({ pieceLevelList: convertedResponse })
    },
    ExportPendingCashAction: async (data: IFilter) => {
        const response = await ExportPendingCashService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
    },
    GetPodInProgressAction: async () => {
        const response = await GetPodInProgressService();
        const convertedResponse = responseData(response?.data);
        set({ podDispatchInProgressList: convertedResponse })
    },
    GetPodInProgressPaginatedAction: async (paginationParams: PaginationParams, filterParams?: IPodFilterParams) => {
        const response = await GetPodInProgressPaginatedService(paginationParams, filterParams, isAoneUrl());
        set({ podDispatchInProgressList: response?.data?.data || [] });
        set({ totalPodDispatchInProgress: response?.data?.totalNumberOfAllElements ?? 0 });
    },
    GetPodPendingAction: async () => {
        const response = await GetPodPendingService();
        const convertedResponse = responseData(response?.data);
        set({ podDispatchPendingList: convertedResponse })
    },
    GetPodCloseAction: async () => {
        const response = await GetPodCloseService();
        const convertedResponse = responseData(response?.data);
        set({ podClosedList: convertedResponse })
    },
    GetPodClosedPaginatedAction: async (paginationParams: PaginationParams, filterParams?: IPodFilterParams) => {
        const response = await GetPodClosedPaginatedService(paginationParams, filterParams, isAoneUrl());
        set({ podClosedList: response?.data?.data || [] });
        set({ totalPodClosed: response?.data?.totalNumberOfAllElements ?? 0 });
    },
    PrintDeliverySheetAction: async (id: number) => {
        const response = await PrintDeliverySheetService(id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { response: file } = responseData(response?.data);
            trackPromise(downloadURL(file), 'operation-print-area');
        }
    },
    GetPodDispatchWaybillsAction: async () => {
        const response = await GetPodDispatchWaybillsService();
        const convertedResponse = responseData(response?.data);
        set({ podDispatchWaybillsList: convertedResponse })
    },
    PrintPodDispatchAction: async (waybill: string | undefined) => {
        const response = await PrintPodDispatchService(waybill)
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(downloadURL(data?.response), 'pod-list-area')
        }
    },
    GetPodWaybillsAction: async (wayBillNumber: string) => {
        const response = await GetPodWaybillsService(wayBillNumber);
        set({ podWaybillsList: responseData(response?.data) });
    },
    SavePodWaybillsAction: async (wayBillNumber: string, data: IPodWaybillsRequestList) => {
        const response = await SavePodWaybillsService(data);
        getNotificationStyle(response);
        get().GetPodWaybillsAction(wayBillNumber)
    },
    GetIndustriesGroupListAction: async () => {
        const response = await GetIndustriesGroupListService();
        set({ industryGroupList: responseData(response?.data) })
    },
    SearchPieceBarcodeTrackingFilterAction: async (filteredData: IPieceTrackingSearchFilter) => {
        const response = await SearchPieceBarcodeTrackingFilterService(filteredData);
        set({ pieceBarcodeTrackingList: responseData(response?.data) })
    },
    GetActivityListAction: async () => {
        const response = await GetActivityListService();
        set({ activityList: responseData(response?.data) })
    },
    GetPackagingListAction: async () => {
        const response = await GetPackagingListService();
        set({ packagingList: responseData(response?.data) })
    },
    GetTruckTypeListAction: async () => {
        const response = await GetTruckTypeListService();
        set({ truckTypeList: responseData(response?.data) })
    },
    GetMarkenByIdAction: async (id?: number) => {
        const response = await GetMarkenByIdService(id);
        set({ markenRequestList: responseData(response?.data) })
    },
    SaveMarkenAction: async (data?: Partial<IMarkenResponse>) => {
        const response = await SaveMarkenService(data);
        getNotificationStyle(response);
    },
    UpdateMarkenAction: async (id: number | undefined, data: IMarkenResponse) => {
        const response = await UpdateMarkenService(id, data);
        getNotificationStyle(response);
    },
    PrintCashRecieptAction: async (airWayBill: string) => {
        const response = await PrintCashRecieptService(airWayBill);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            downloadBlob(responseData(response?.data)?.response, `${airWayBill}.pdf`);
        }
    },
    PrintIRSReportAction: async (airWayBill: string) => {
        const response = await PrintIRSReportService(airWayBill);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            downloadBlob(responseData(response?.data)?.response, `${airWayBill}.pdf`);
        }
    },
    GetAirportCodeListAction: async () => {
        const response = await GetAirportCodeListService();
        set({ airportCodeList: responseData(response?.data) })
    },
    GetShipmentTemperatureListAction: async () => {
        const response = await GetShipmentTemperatureListService();
        set({ shipmentTemperatureList: responseData(response?.data) })
    },
    GetPackageTempListAction: async (id: number) => {
        const response = await GetPackageTempListService(id);
        set({ packageTempList: responseData(response?.data) });
    },
    GetPackageSizeListAction: async (id: number) => {
        const response = await GetPackageSizeListService(id);
        set({ packageSizeList: responseData(response?.data) });
    },
    GetMarkenFilesListAction: async (wayBillNumber: string) => {
        const response = await GetMarkenFilesListService(wayBillNumber);
        set({ markenFiles: responseData(response?.data) });
    },
    DownloadMarkenFilesAction: async (id: number, fileName: string, fileFormat: string) => {
        const response = await DownloadMarkenFilesService(id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ download: responseData(response?.data) });
            downloadBlob(responseData(response?.data), fileName, fileFormat);
        }
    },
    GetManifestSalesmanAction: async (data: IManifestChargeFilter) => {
        const response = await GetManifestSalesmanService(data);
        const modifiedResponse = response?.data.data?.map((item: IManifestSalesManList) => {
            return {
                ...item,
                id: getUniqueId()
            }
        });
        set({ manifestSalesman: modifiedResponse });
    },
    ConfirmManifestByIdAction: async (data: ISalesPersonManifestRespond, id: number) => {
        const response = await ConfirmManifestByIdService(data, id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
        }
    },
    RejectManifestByIdAction: async (data: ISalesPersonManifestRejectRequest, id: number, closeManifestModal?: () => void) => {
        const response = await RejectManifestByIdService(data, id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            if (closeManifestModal) closeManifestModal();
        }
    },
    GetCustomerComplaintListAction: async () => {
        const response = await GetCustomerComplaintListService();
        const convertedResponse = responseData(response?.data);
        set({ customerComplaintList: convertedResponse })
    },
    GetComplaintCategoryListAction: async () => {
        const response = await GetComplaintCategoryListService();
        set({ customerComplaintCategoryList: responseData(response?.data) })
    },
    GetComplaintPriorityListAction: async () => {
        const response = await GetComplaintPriorityListService();
        set({ customerComplaintPriorityList: responseData(response?.data) })
    },
    GetComplaintStatusListAction: async () => {
        const response = await GetComplaintStatusListService();
        set({ customerComplaintStatusList: responseData(response?.data) })
    },
    SaveCustomerComplaintAction: async (data: ICustomerComplaintList) => {
        const response = await SaveCustomerComplaintService(data);
        // save files
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) { 
            const data: ICustomerComplaintList = responseData(response?.data);
            const uploadFileList = get().uploadedFiles ?? [];
            if (uploadFileList?.length) {
                uploadFileList.forEach(item => {
                    if (item?.name !== undefined) {
                        const request: IFile = {
                            wayBillNumber: undefined,
                            category: CUSTOMER_COMPLAINT,
                            fileType: CUSTOMER_COMPLAINT,
                            files: new Array(item),
                            categoryId: String(data.id),
                            generic: String(true)
                        }
                        const { formData, configuration } = CustomerUploadFormData(request);
                        trackPromise(get().UploadFileAction({ formData, configuration }), 'upload-file-area');
                    }
                });
            }
            trackPromise(get().GetCustomerComplaintListAction(), 'customer-details-area');
            set({ customerComplaintSavingResponse: statusCode });
            getNotificationStyle(response);
        }
    },
    GetCustomerComplaintByIdAction: async (id: number) => {
        const response = await GetCustomerComplaintByIdService(id);
        set({ customerComplaintRequestList: responseData(response?.data) })
    },
    GetCommentByComplaintAction: async (id: number) => {
        const response = await GetCommentByComplaintService(id);
        set({ customerComplaintCommentsList: responseData(response?.data) })
    },
    UpdateCustomerComplaintAction: async (id: number | undefined, data: ICustomerComplaintList) => {
        const response = await UpdateCustomerComplaintService(id, data);
        getNotificationStyle(response);
        trackPromise(get().GetCustomerComplaintByIdAction(id!), 'customer-details-area');
    },
    SaveCustomerComplaintCommentsAction: async (data: IComplaintCommentsList) => {
        const response = await SaveCustomerComplaintCommentsService(data);
        getNotificationStyle(response);
        trackPromise(get().GetCommentByComplaintAction(data.customerComplaintId), 'customer-details-area');
        trackPromise(get().GetCustomerComplaintByIdAction(data.customerComplaintId), 'customer-details-area');
        trackPromise(get().GetComplaintHistoryByComplaintAction(data.customerComplaintId), 'customer-details-area');
    },
    SearchComplaintFilterAction: async (filteredData: ICustomerComplaintFilter) => {
        const response = await SearchComplaintFilterService(filteredData);
        set({ customerComplaintList: responseData(response?.data) })
    },
    GetComplaintSubCategoryByCategoryAction: async (id: number) => {
        const response = await GetComplaintSubCategoryByCategoryService(id);
        set({ customerComplaintSubCategoryList: responseData(response?.data) })
    },
    GetCustomerInfoByWaybillAction: async (waybill: string) => {
        const response = await GetCustomerInfoByWaybillService(waybill);
        set({ customerInfo: responseData(response?.data) })
    },
    AssignComplaintAction: async (id: number | undefined, data: IComplaintAssignment) => {
        const response = await AssignComplaintService(id, data);
        getNotificationStyle(response);
        trackPromise(get().GetCustomerComplaintByIdAction(id!), 'customer-details-area');
        trackPromise(get().GetComplaintHistoryByComplaintAction(id!), 'customer-details-area');
    },
    GetComplaintHistoryByComplaintAction: async (id: number) => {
        const response = await GetComplaintHistoryByComplaintService(id);
        set({ complaintHistoryList: responseData(response?.data) })
    },
    GetComplaintUploadFileAction: async (request: IFetchFiles) => {
        const response = await GetComplaintUploadFileService(request);
        const { statusCode } = response?.data || {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) getNotificationStyle(response);
        set({ uploadedFiles: responseData(response?.data) });
    },
    UploadFileAction: async (request: { formData: FormData, configuration: {} }) => {
        const response = await UploadFileService(request);
        const { statusCode } = response?.data ?? {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) getNotificationStyle(response)
        set({ uploadedFiles: [] })
    },
    UploadFileState: (files: [] = []) => {
        set({
            uploadedFiles: [
                ...files]
        });
    },
    DeleteUploadFileState: (files: any = {}) => {
        const list: any[] = get().uploadedFiles ?? [];
        const filtered = list?.filter(item => item?.uid !== files?.uid);
        set({ uploadedFiles: filtered });
    },
    GetPodDispatchWaybillsPageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetPodDispatchWaybillsPageService(pageNumber, pageSize, isAoneUrl());
        const { totalPages, isLast, numberOfElements, page, totalNumberOfAllElements } = response?.data || {};
        set({
            podDispatchWaybillsList: {
                podDispatchWaybills: responseData(response?.data),
                pagination: { totalPages, isLast, numberOfElements, page, totalNumberOfAllElements }
            },
        });
    },
    GetVehicleVisibilityListAction: async () => {
        const response = await GetVehicleVisibilityListService();
        set({ vehicleVisibilityList: responseData(response?.data) });
    },
    GetVehicleVisibilityByIdAction: async (id: number) => {
        const response = await GetVehicleVisibilityByIdService(id);
        set({ vehicleVisibilityIdList: [] });
        const item = responseData(response?.data);
        const modifiedResponse = Object.assign({}, item, {
            availableFrom:
                item?.availableFrom === undefined
                    ? undefined
                    : convertMillisToDateMoment(item?.availableFrom),
            eta:
                item?.eta === undefined
                    ? undefined
                    : convertMillisToDateMoment(item?.eta),
            etd:
                item?.etd === undefined
                    ? undefined
                    : convertMillisToDateMoment(item?.etd),
        });
        set({ vehicleVisibilityIdList: modifiedResponse });
    },

    GetVehicleStatusHistoryByIdAction: async (id: number) => {
        const response = await GetVehicleStatusHistoryByIdService(id);
        set({ vehicleStatusHistoryList: responseData(response?.data) });
    },
    UpdateVehicleVisibilityByIdAction: async (
        id: number | undefined,
        data: IVehicleVisibility
    ) => {
        const response = await UpdateVehicleVisibilityByIdService(id, data);
        getNotificationStyle(response);
        trackPromise(
            get().GetVehicleVisibilityListAction(),
            "visibility-list-area"
        );
    },
    SearchVehicleVisibilityFilterAction: async (filteredData) => {
        set({ vehicleVisibilityList: [] });
        const response = await SearchVehicleVisibilityFilterService(filteredData);
        set({
            vehicleVisibilityList: responseData(response?.data).map(
                (item: IVehicleVisibility) => ({
                    ...item,
                    assignedDate: addLeadingZero(item?.assignedDate),
                    assignedAcknowledgedDate: addLeadingZero(
                        item?.assignedAcknowledgedDate
                    ),
                    unassignedDate: addLeadingZero(item?.unassignedDate),
                    unassignedDateAcknowledgedDate: addLeadingZero(
                        item?.unassignedDateAcknowledgedDate
                    ),
                    unassignedAcknowledgedDate: addLeadingZero(
                        item?.unassignedAcknowledgedDate
                    ),
                })
            ),
        });
    },
    AssignUnAssignAction: async ({
        request,
        filter,
        driverId,
        key,
    }: {
        request: IAssignUnAssignType;
        filter?: IVehicleVisibilityFilter;
        driverId?: number;
        key?: string;
    }) => {
        const response = await AssignUnAssignService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            if (filter)
                trackPromise(
                    get().SearchVehicleVisibilityFilterAction(filter),
                    "search-vehicle-area"
                );
            if (driverId)
                trackPromise(
                    get().GetDriverAssignmentByIdAction(driverId, key),
                    "assigned-driver-area"
                );
        }
    },
    AdhocAssignUnAssignAction: async ({
        request,
        filter,
        driverId,
        key,
    }: {
        request: IAssignUnAssignType;
        filter?: IVehicleVisibilityFilter;
        driverId?: number;
        key?: string;
    }) => {
        const response = await AdhocAssignUnAssignService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            if (filter)
                trackPromise(
                    get().SearchVehicleVisibilityFilterAction(filter),
                    "search-vehicle-area"
                );
            if (driverId)
                trackPromise(
                    get().GetDriverAssignmentByIdAction(driverId, key),
                    "assigned-driver-area"
                );
        }
    },
    CancelAction: async ({
        request,
        filter,
        driverId,
        key,
    }: {
        request: ICancelRequest;
        filter?: IVehicleVisibilityFilter;
        driverId?: number;
        key?: string;
    }) => {
        const response = await CancelService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            if (filter)
                trackPromise(
                    get().SearchVehicleVisibilityFilterAction(filter),
                    "search-vehicle-area"
                );
            if (driverId)
                trackPromise(
                    get().GetDriverAssignmentByIdAction(driverId, key),
                    "assigned-driver-area"
                );
        }
    },
    NotifyDriverAction: async ({ request }: { request: INotify }) => {
        const response = await NotifyDriverService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
        }
    },
    GetDriverAssignmentByIdAction: async (id?: number, key?: string) => {
        set({ assignedDrivers: [] });
        if (!id) {
            if (key && ["deliveryDriver"].includes(key)) {
                set({ deliveryDrivers: [] });
            } else {
                set({ assignedDrivers: [] });
            }
            return;
        }
        // set({ assignedVehicle: {} });
        const response = await GetDriverAssignmentByIdService(id);
        if (key && ["deliveryDriver"].includes(key)) {
            set({ deliveryDrivers: responseData(response?.data) });
        }
        set({ assignedDrivers: responseData(response?.data) });
    },
    GetVehicleAssignmentByIdAction: async (id?: number, key?: string) => {
        set({ assignedVehicle: {} });
        if (!id) {
            set({ assignedVehicle: {} });
            return;
        }
        set({ assignedDrivers: [] });
        const response = await GetVehicleAssignmentByIdService(id);
        const data = response?.data;
        if (data?.statusCode === TWO_HUNDRED_SUCCESS_CODE && !data.data) {
            set({ assignedVehicle: { vehicleId: id } });
        } else {
            set({ assignedVehicle: responseData(data) });
        }
    },
    DownloadSingleFileAction: async (id: number, fileName: string, fileFormat: string) => {
        const response = await DownloadSingleFileService(id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ download: responseData(response?.data) });
            trackPromise(downloadBlob(responseData(response?.data)?.file, fileName, fileFormat), 'download-file-area');
        }
    },
    GetPickupCountForMonthAction: async (shipmentSummaryRequest: IShipmentSummaryRequest) => {
        const response = await GetPickupCountForMonthService(shipmentSummaryRequest);
        set({ pickupCountForMonthList: responseData(response?.data) || [] });
    },
    GetShipmentStatusCountForDayAction: async (shipmentSummaryRequest: IShipmentSummaryRequest) => {
        const response = await GetShipmentStatusCountForDayService(shipmentSummaryRequest);
        set({ shipmentStatusCountForDayList: responseData(response?.data) || [] });
    },
    GetShipmentStatusDetailForDayAction: async (shipmentSummaryDetailsRequest: IShipmentSummaryDetailsRequest, paginationParams: PaginationParams) => {
        const response = await GetShipmentStatusDetailForDayService(shipmentSummaryDetailsRequest, paginationParams);
        set({ shipmentStatusDetailForDayList: responseData(response?.data) || [] });
        set({ shipmentStatusDetailForDayTotal: response?.data?.totalNumberOfAllElements ?? 0 });
    },
    GetFuelPaymentModesAction: async () => {
        const response = await GetFuelPaymentModesService();
        set({ fuelPaymentModes: responseData(response?.data) || [] });
    },
    GetFuelStationsAction: async () => {
        const response = await GetFuelStationsService();
        set({ fuelStations: responseData(response?.data) || [] });
    },
    GetFuelTrackingListAction: async (paginationParams: PaginationParams, filterParams?: IFuelFilterParams) => {
        const response = await GetFuelTrackingListService(paginationParams, filterParams);
        set({ fuelTrackingList: responseData(response?.data) || [] });
        set({ fuelTrackingTotal: response?.data?.totalNumberOfAllElements ?? 0 });
    },
    AddFuelTrackingAction: async (request, paginationParams, filterParams) => {
        const response = await AddFuelTrackingService(request);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            trackPromise(get().GetFuelTrackingListAction(paginationParams, filterParams), "get-fuel-tracking-list");
            return (data?.auditId as number) ?? null;
        }
        return null;
    },
    EditFuelTrackingAction: async (request, id, paginationParams, filterParams) => {
        const response = await EditFuelTrackingService(request, id);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            trackPromise(get().GetFuelTrackingListAction(paginationParams, filterParams), "get-fuel-tracking-list");
            return (data?.auditId as number) ?? null;
        }
        return null;
    },
    GetFuelAuditHistoryAction: async (id: number) => {
        set({ fuelAuditHistory: [] });
        const response = await GetFuelAuditHistoryService(id);
        set({ fuelAuditHistory: responseData(response?.data) || [] });
    },
    GetFuelAuditPaginatedAction: async (paginationParams: PaginationParams, filterParams: IFuelAuditPaginatedFilterParams) => {
        const response = await GetFuelAuditPaginatedService(paginationParams, filterParams);
        set({ fuelAuditPaginatedList: responseData(response?.data) || [] });
        set({ fuelAuditPaginatedTotal: response?.data?.totalNumberOfAllElements ?? 0 });
    },
    UploadImageAction: async (request: { formData: FormData, configuration: {} }) => {
        try {
            const response = await UploadFileService(request);
            const { statusCode } = response?.data ?? {};
            if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) {
                getNotificationStyle(response);
                return false;
            }
            return true;
        } catch {
            return false;
        }
    },
    DownloadImageAction: async (request: IGetFiles, onFinish?: () => void) => {
        const response = await GetUploadedFileListService(request);
        const { statusCode } = response?.data || {};

        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
        } else {
            const uploadedFileList = responseData(response?.data);

            if (!uploadedFileList?.length) {
                getNotificationStyle({ message: "Image Not Uploaded!" });
            } else {
                const resp = await DownloadSingleFileService(uploadedFileList[0]?.id);
                const { statusCode } = resp?.data || {};

                if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) {
                    getNotificationStyle(resp);
                } else {
                    downloadBlob(responseData(resp?.data)?.file, uploadedFileList[0]?.originalFileName, uploadedFileList[0]?.fileFormat);
                }
            }
        }

        onFinish?.();
    },
    GetFuelRateListAction: async (countryId: number) => {
        set({ fuelRateList: [] });
        const response = await GetFuelRateListService(countryId);
        set({ fuelRateList: responseData(response?.data) || [] });
    },
    GetOdometerListAction: async (paginationParams: PaginationParams, filterParams?: IOdometerFilterParams) => {
        const response = await GetOdometerListService(paginationParams, filterParams);
        set({ odometerList: responseData(response?.data) || [] });
        set({ odometerTotal: response?.data?.totalNumberOfAllElements ?? 0 });
    },
    EditOdometerAction: async (request, id, paginationParams, filterParams, onSuccess) => {
        const response = await EditOdometerService(request, id);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            onSuccess();
            trackPromise(get().GetOdometerListAction(paginationParams, filterParams), "get-odometer-list");
        }
    },
    GetMetabaseReportListAction: async () => {
        const response = await GetMetabaseReportListService();
        set({ metabaseReportList: responseData(response?.data) || [] });
    },
    GetMetabaseSignedTokenAction: async (data: MetabaseRequestData) => {
        const response = await GetMetabaseSignedTokenService(data);
        set({ metabaseSignedToken: responseData(response?.data) || "" });
    },
    GetFTLNonAutoTripPlanWaybillsAction: async (paginationParams: PaginationParams, filterParams?: IFTLTripPlanFilterParams) => {
        const response = await GetFTLNonAutoTripPlanWaybillsService(paginationParams, filterParams);
        set({ ftlNonAutoTripPlanWaybills: responseData(response?.data) || [] });
        set({ ftlNonAutoTripPlanWaybillsTotal: response?.data?.totalNumberOfAllElements ?? 0 });
    },
    GetIdleVehicleListAction: async (paginationParams, filterParams) => {
        const response = await GetIdleVehicleListService(paginationParams, filterParams);
        set({ idleVehicleList: responseData(response?.data) || [] });
        set({ idleVehicleTotal: response?.data?.totalNumberOfAllElements ?? 0 });
    },
    GetIdleVehicleByIdAction: async (id) => {
        const response = await GetIdleVehicleByIdService(id);
        set({ idleVehicle: responseData(response?.data) || undefined });
    },
    CreateIdleVehicleExceptionAction: async (data, onSuccess, paginationParams, filterParams) => {
        const response = await CreateIdleVehicleExceptionService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            onSuccess();
            trackPromise(get().GetIdleVehicleListAction(paginationParams, filterParams), "get-idle-vehicle-list");
        }
    },
    EditIdleVehicleExceptionAction: async (id, data, onSuccess, paginationParams, filterParams) => {
        const response = await EditIdleVehicleExceptionService(id, data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            onSuccess();
            trackPromise(get().GetIdleVehicleListAction(paginationParams, filterParams), "get-idle-vehicle-list");
        }
    },
    CancelIdleVehicleExceptionAction: async (id, data, onSuccess, paginationParams, filterParams) => {
        const response = await CancelIdleVehicleExceptionService(id, data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            onSuccess();
            trackPromise(get().GetIdleVehicleListAction(paginationParams, filterParams), "get-idle-vehicle-list");
        }
    },
    ApproveRejectIdleVehicleExceptionAction: async (id, data, onSuccess, paginationParams, filterParams) => {
        const response = await ApproveRejectIdleVehicleExceptionService(id, data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            onSuccess();
            trackPromise(get().GetIdleVehicleListAction(paginationParams, filterParams), "get-idle-vehicle-list");
        }
    },
    GetCustomerConfigAction: async (waybillNo) => {
        const response = await GetCustomerConfigService(waybillNo);
        set({ customerConfig: responseData(response?.data) || null });
    },
    GetInvoiceStagingAction: async (params, filterParams) => {
        const response = await GetInvoiceStagingService(params, filterParams);
        const modifiedResponse: InvoiceStaging[] = responseData(response?.data)?.map((item: any) => {
            const { businessUnit, customerName, mainAccount, subAccountNo, origin, destination, pickupDate, deliveryDate,
                manifesterConfirmDate, additionalCharge, codServiceCharge, demurrageCharge, destinationOdaCharge, fsc,
                forkliftAmount, labourCharge, netAmount, originOdaCharge, podCharge, serviceCharge, stdShipmentAmount,
                totalAmount, unitSellingPrice, vatAmount, vatPercentage
            } = item?.aimsInvoiceData || {};
            return {
                businessUnit: businessUnit,
                customerName: customerName,
                mainAccount: mainAccount,
                customerAccount: subAccountNo,
                waybillNo: item?.waybillNo,
                origin: origin,
                destination: destination,
                pickupDate: pickupDate,
                deliveryDate: deliveryDate,
                manifesterConfirmDate: manifesterConfirmDate,
                status: item?.status,
                additionalCharge: additionalCharge,
                codServiceCharge: codServiceCharge,
                demurrageCharge: demurrageCharge,
                destinationOdaCharge: destinationOdaCharge,
                forkliftAmount: forkliftAmount,
                fsc: fsc,
                labourCharge: labourCharge,
                netAmount: netAmount,
                originOdaCharge: originOdaCharge,
                podCharge: podCharge,
                serviceCharge: serviceCharge,
                stdShipmentAmount: stdShipmentAmount,
                totalAmount: totalAmount,
                unitSellingPrice: unitSellingPrice,
                vatAmount: vatAmount,
                vatPercentage: vatPercentage,
                error: item?.errorList?.[item.errorList.length - 1]?.message ?? "",
                errorDate: item?.errorList?.[item.errorList.length - 1]?.timestamp ?? "",
                aimsInvoiceData: item?.aimsInvoiceData || {},
                insertionTimestamp: item?.insertionTimestamp
            };
        }) || [];
        set({ invoiceStaging: modifiedResponse });
    },
    PushToOracleStagingAction: async (payload, onSuccess) => {
        const response = await PushToOracleStagingService(payload);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            onSuccess();
        }
    },
    RevalidateInvoiceStagingAction: async (payload, onSuccess) => {
        const response = await RevalidateInvoiceStagingService(payload);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            onSuccess();
        }
    },
    AllowEditInvoiceStagingAction: async (payload, onSuccess) => {
        const response = await AllowEditInvoiceStagingService(payload);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            onSuccess();
        }
    },
    GetCaseClosureTypesAction: async () => {
        const response = await GetCaseClosureTypesService();
        set({ ComplaintCaseTypesList: responseData(response?.data) })
    },
    GetCnNoteReasonsAction: async () => {
        const response = await GetCnNoteReasonsService();
        set({ cnNoteReasonsList: responseData(response?.data) })
    },


    GetCROPersonAction: async (req) => {
        const response = await GetCROEmployeesService(req);
        set({ croPersonList: responseData(response?.data)?.filter((croPerson: ICROPerson) => croPerson?.statusId === ACTIVE_STATUS_ID) })
    },



    uploadCustomerComplaintFile: async (id: number) => {
        const uploadFileList = get().uploadedFiles ?? [];

        if (uploadFileList?.length) {
            const uploadPromises = uploadFileList
                .filter(item => item?.name !== undefined)
                .map(item => {
                    const request: IFile = {
                        wayBillNumber: undefined,
                        category: CUSTOMER_COMPLAINT,
                        fileType: CUSTOMER_COMPLAINT,
                        files: new Array(item),
                        categoryId: String(id),
                        generic: String(true)
                    };
                    const { formData, configuration } = CustomerUploadFormData(request);
                    return trackPromise(
                        get().UploadFileAction({ formData, configuration }),
                        'upload-file-area'
                    );
                });

            await Promise.all(uploadPromises);
        }

        trackPromise(
            get().GetComplaintUploadFileAction({
                categoryId: id,
                category: 'Customer Complaint',
                fileType: 'Customer Complaint',
            }),
            'download-file-area'
        );
    },

       GetRouteTypeListAction: async () => {
        const response = await GetRouteTypesService();
        set({ routeTypeList: responseData(response?.data) })
    },


    ClearComplaintUploadedFileList: () => set({ uploadedFiles: [] }),
    ClearCustomerComplaintSavingResponse: () => set({ customerComplaintSavingResponse: undefined }),
    ClearCustomerInfo: () => set({ customerInfo: undefined }),
    ClearCustomerComplaintRequestList: () => set({ customerComplaintRequestList: [] }),
    ClearComplaintHistoryList: () => set({ complaintHistoryList: [] }),
    CleaCustomerComplaintCommentsList: () => set({ customerComplaintCommentsList: [] }),
    ClearManifestSalesManList: () => set({ manifestSalesman: [] }),
    ClearAssignedDrivers: () => set({ assignedDrivers: [] }),
})))


export const useCommonStore = (CommonStore);


type IApplicationState = {
    customerState: string,
    setCustomerState: (id: string) => void
}

const ApplicationStateStore = create<IApplicationState>(((set) => ({
    customerState: '1',
    setCustomerState: (currentState: string) => {
        set({ customerState: currentState })
    }
})));

export const useApplicationStore = (ApplicationStateStore)